<template>
  <div class="polar-chart-loader">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 150 200"
      width="200"
      class="loader"
    >
      <defs>
        <path
          d="M146.32 71.99C146.32 111.72 114.06 143.97 74.33 143.97C34.6 143.97 2.35 111.72 2.35 71.99C2.35 32.26 34.6 0 74.33 0C114.06 0 146.32 32.26 146.32 71.99Z"
          id="jRHPh46y"
        />
        <path
          d="M128.94 71.99C128.94 102.13 104.47 126.6 74.33 126.6C44.19 126.6 19.72 102.13 19.72 71.99C19.72 41.85 44.19 17.38 74.33 17.38C104.47 17.38 128.94 41.85 128.94 71.99Z"
          id="a2fmJNEbGz"
        />
        <path
          d="M108.38 71.99C108.38 90.77 93.12 106.03 74.33 106.03C55.55 106.03 40.29 90.77 40.29 71.99C40.29 53.2 55.55 37.94 74.33 37.94C93.12 37.94 108.38 53.2 108.38 71.99Z"
          id="gaSHP5GaGd"
        />
        <path d="M2.35 60.6L75.26 71.99L11.89 35.94L2.35 60.6Z" id="a1U9FFrxqz" />
        <path d="M104.26 26.17L74.99 71.78L121.86 43.35L104.26 26.17Z" id="b6SFCFi1fx" />
      </defs>
      <g>
        <g>
          <g>
            <g>
              <use xlink:href="#jRHPh46y" opacity="1" fill="#ffffff" fill-opacity="1" />
              <g>
                <use
                  xlink:href="#jRHPh46y"
                  opacity="1"
                  fill-opacity="0"
                  stroke="#f2f2f2"
                  stroke-width="1"
                  stroke-opacity="1"
                />
              </g>
            </g>
            <g>
              <use xlink:href="#a2fmJNEbGz" opacity="1" fill="#ffffff" fill-opacity="1" />
              <g>
                <use
                  xlink:href="#a2fmJNEbGz"
                  opacity="1"
                  fill-opacity="0"
                  stroke="#f2f2f2"
                  stroke-width="1"
                  stroke-opacity="1"
                />
              </g>
            </g>
            <g>
              <use xlink:href="#gaSHP5GaGd" opacity="1" fill="#ffffff" fill-opacity="1" />
              <g>
                <use
                  xlink:href="#gaSHP5GaGd"
                  opacity="1"
                  fill-opacity="0"
                  stroke="#f2f2f2"
                  stroke-width="1"
                  stroke-opacity="1"
                />
              </g>
            </g>
            <g>
              <use xlink:href="#a1U9FFrxqz" opacity="1" fill="#f2f2f2" fill-opacity="1" />
              <g>
                <use
                  xlink:href="#a1U9FFrxqz"
                  opacity="1"
                  fill-opacity="0"
                  stroke="#e9e9e9"
                  stroke-width="0"
                  stroke-opacity="1"
                />
              </g>
            </g>
            <g>
              <use xlink:href="#b6SFCFi1fx" opacity="1" fill="#f2f2f2" fill-opacity="1" />
              <g>
                <use
                  xlink:href="#b6SFCFi1fx"
                  opacity="1"
                  fill-opacity="0"
                  stroke="#e9e9e9"
                  stroke-width="0"
                  stroke-opacity="1"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'PolarChartLoader',
  components: {
    ContentLoader,
  },
  computed: {
    calculatedHeight() {
      return window.innerHeight >= 900 ? 170 : window.innerHeight;
    },
  },
};
</script>
<style lang="scss">
@keyframes hideshow {
  0% {
    opacity: 1;
  }
  10% {
    opacity: 0.9;
  }
  15% {
    opacity: 0.6;
  }
  100% {
    color: #ecebeb;
    opacity: 0.2;
  }
}

.polar-chart-loader {
  display: block;
  padding-left: 10px;
  text-align: center;
  .loader {
    animation: hideshow 1.5s ease-in-out infinite;
  }
}
</style>



// WEBPACK FOOTER //
// PolarChartLoader.vue?2079af62